import type { TooltipProps } from '@packages/modules/src/Tooltip/TooltipProps';
import type { TooltipDataContentSnippetType, TooltipDataPromotionType } from '../../interfaces';

export const getTooltipContent = (
  promotion?: TooltipDataPromotionType,
  contentSnippet?: TooltipDataContentSnippetType,
): TooltipProps['content'] => {
  let tooltipContentSnippet: TooltipProps['content'] | undefined;
  if (contentSnippet) {
    if (Array.isArray(contentSnippet)) {
      tooltipContentSnippet =
        contentSnippet?.find((item) => item.bundle === 'tooltip' && item.field_conditions)
          ?.field_conditions ?? undefined;
    } else if (
      contentSnippet.field_conditions &&
      typeof contentSnippet.field_conditions === 'object'
    ) {
      tooltipContentSnippet = contentSnippet.field_conditions.processed;
    }
  }

  const tooltipContent =
    promotion?.find((item) => item)?.field_promotion_feedback_descrip ?? tooltipContentSnippet;

  return tooltipContent;
};
